module.exports = __webpack_public_path__ + "static/media/streetlink.d1d1217d.png";